import * as ActionTypes from "constants/ActionTypes";

export default function storyPublishSettings(
  state = {
    customTwitterMessage: null,
    embedCode: "",
    hasLoaded: false,
    storySharingUrl: null,
  },
  action,
) {
  switch (action.type) {
    case ActionTypes.STORY_PUBLISH_SETTINGS_LOADED:
      return {
        hasLoaded: true,
        ...action.settings,
      };
    default:
      return state;
  }
}
